import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import SponsorLangForm from './SponsorLangForm'
import { Notice, SkeletonForm, EmptyState } from './media'
import './media.css'

/*
 * SPONSOR — the languages.
 *
 * GET admin/lang is unchanged; only the tab strip is ours now instead of
 * react-bootstrap's, so it takes the same tokens as everything else and scrolls
 * sideways on a phone instead of wrapping into a stack of pills.
 *
 * The child still receives LangID={item.UUID} — the same value the form has
 * always posted.
 */

export default function SponsorLang(props) {

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [failed, setFailed] = useState('')
  const [active, setActive] = useState(null)

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadData = () => {
    setIsLoading(true)
    setFailed('')
    axios.get(process.env.REACT_APP_API_SERVER + 'admin/lang', {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    })
      .then(res => {
        setData(res.data.results)
        setIsLoading(false)

      }).catch(err => {
        setIsLoading(false)
        setFailed('Languages could not be loaded.')
      })
  }

  const list = Array.isArray(data) ? data : []
  const current = list.find((item) => item.LangID === active) || list[0]

  return (
    <Panel
      title="Sponsor Languages"
      subtitle={list.length > 0 ? list.length + ' content languages' : 'Title and description per language'}
    >
      {failed ? <Notice kind="crit" onClose={() => setFailed('')}>{failed}</Notice> : null}

      {isLoading ? <SkeletonForm rows={2} /> : null}

      {!isLoading && list.length === 0 && !failed ? (
        <EmptyState title="No languages" hint="No content languages have been set." />
      ) : null}

      {!isLoading && list.length > 0 ? (
        <>
          <div className="md-tabs" role="tablist" aria-label="Sponsor Languages">
            {list.map((item) => (
              <button
                key={item.LangID}
                type="button"
                role="tab"
                className="md-tab"
                aria-selected={current && current.LangID === item.LangID}
                onClick={() => setActive(item.LangID)}
              >
                {item.LangName}
              </button>
            ))}
          </div>

          {current ? (
            <SponsorLangForm key={current.UUID} id={props.id} LangID={current.UUID} />
          ) : null}
        </>
      ) : null}
    </Panel>
  )
}
